import { render, staticRenderFns } from "./SetMenuList.vue?vue&type=template&id=f42d2b28&scoped=true"
import script from "./SetMenuList.vue?vue&type=script&lang=js"
export * from "./SetMenuList.vue?vue&type=script&lang=js"
import style0 from "./SetMenuList.vue?vue&type=style&index=0&id=f42d2b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42d2b28",
  null
  
)

export default component.exports